var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "admin-settings"
  }, [_c('v-btn', {
    staticClass: "mb-3",
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v("Redirection Settings (custom STC)")]), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: _vm.openModal,
      callback: function callback($$v) {
        _vm.openModal = $$v;
      },
      expression: "openModal"
    }
  }, [_c('v-card', {
    staticClass: "d-flex flex-column"
  }, [_c('v-toolbar', {
    staticClass: "flex-grow-0",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1), _c('v-toolbar-title', [_vm._v("Admin Settings (ADMIN ONLY)")]), _c('v-spacer'), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "disabled": _vm.loading,
      "text": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1), _c('v-card-text', {
    staticClass: "flex-grow-1 pa-5"
  }, [_c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" Global ")]), _c('div', {
    staticClass: "section"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Redirect URL"
    },
    model: {
      value: _vm.redirect,
      callback: function callback($$v) {
        _vm.redirect = $$v;
      },
      expression: "redirect"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Preview URL"
    },
    model: {
      value: _vm.preview,
      callback: function callback($$v) {
        _vm.preview = $$v;
      },
      expression: "preview"
    }
  })], 1)])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }